import { createAppAsyncThunk } from '../store/extensions';
import { ChatMessageDto } from './dtos';
import {
  fetchChatsCall,
  fetchMessagesCall,
  hideConversationCall,
  readConversationCall,
  sendMessageCall,
} from './service';

export const fetchChats = createAppAsyncThunk(
  'chats/getAll',
  (
    doNotRenewTokenOrArg?:
      | boolean
      | { doNotRenewToken?: boolean; clientAction?: string }
  ) => {
    const doNotRenewToken =
      typeof doNotRenewTokenOrArg === 'boolean'
        ? doNotRenewTokenOrArg
        : doNotRenewTokenOrArg?.doNotRenewToken;
    const clientAction =
      typeof doNotRenewTokenOrArg === 'boolean'
        ? undefined
        : doNotRenewTokenOrArg?.clientAction;

    return fetchChatsCall(doNotRenewToken, clientAction);
  }
);

export const fetchMessages = createAppAsyncThunk(
  'chat/getMessages',
  (arg: {
    companionId: string;
    chatId: string;
    xMsContinuationToken?: string;
    numrecs?: number;
    clientAction?: string;
  }) => {
    return fetchMessagesCall(
      arg.companionId,
      arg.chatId,
      arg.xMsContinuationToken,
      arg.numrecs,
      arg.clientAction
    );
  }
);

export const sendMessage = createAppAsyncThunk(
  'chat/sendMessage',
  (arg: {
    toMemberId: string;
    chatId: string | undefined;
    newChatMessage: ChatMessageDto;
    resend?: boolean;
    messageId?: string;
    clientAction?: string;
  }) => {
    return sendMessageCall(
      arg.toMemberId,
      arg.chatId,
      arg.newChatMessage,
      arg.clientAction
    );
  }
);

export const readConversation = createAppAsyncThunk(
  'chat/readConversation',
  (arg: string | { chatId: string; clientAction?: string }) => {
    const chatId = typeof arg === 'string' ? arg : arg.chatId;
    const clientAction = typeof arg === 'string' ? undefined : arg.clientAction;
    return readConversationCall(chatId, clientAction);
  }
);

export const hideConversation = createAppAsyncThunk(
  'chat/hideConversation',
  (arg: string | { chatId: string; clientAction?: string }) => {
    const chatId = typeof arg === 'string' ? arg : arg.chatId;
    const clientAction = typeof arg === 'string' ? undefined : arg.clientAction;
    return hideConversationCall(chatId, clientAction);
  }
);
